import {createCookie, getCookieVal} from "./utils/Cookie.js";
import {skin} from "./utils/Skin.js";
import {msg} from "@/i18n/Message.ts";
import { Icon } from "anneca-symbols";
import {installCreateDialog, SrcType} from "@fd/main.js";


/************* MENU ***************/

/**
 * Toggle visibility of elements
 * @param {...string} ids	DOM IDs of elements that should be toggled
 */
export function menuClick3(...ids) {
	for (let name of arguments) {
		const el = $("#"+name);
		if (el.is(":visible")) {
			el.hide();
			createCookie(name, "none");
		} else {
			el.show();
			createCookie(name, "display");
		}
	}
}

window.menuClick3 = menuClick3;

/**
 * Find showHideControl which is parent of opener button and tag it with .opened class
 * @param {jQuery} opener
 * @param {boolean} show
 */
function tagShowHideControl(opener, show) {
	let elm = opener.parents(".showHideControl");
	if (show) elm.addClass("opened");
	else elm.removeClass("opened");
}

/**
 * Toggle menu to be open/closed
 * @param {string} mname	ID of the menu (element to be shown/hidden). Cookie with this name is create to remember current state.
 * @param {string} [btnname]	ID of the toggling button (should be triangle image)
 */
export function menuClick(mname, btnname) {
	let el = $('#' + mname);
	if (el.length > 0) {
		if (btnname) {
			let button = $('#' + btnname);
			if (button.hasClass('closed')) {
				button.removeClass('closed');
				el.show();
				localStorage.setItem(mname, 'display');
				tagShowHideControl(button, true);
			} else {
				button.addClass('closed');
				el.fadeOut(200);
				localStorage.setItem(mname, 'none');
				tagShowHideControl(button, false);
			}
		} else {	// without button
			if (el.is(":visible")) {
				el.fadeOut(200);
				localStorage.setItem(mname, 'none');
			} else {
				el.show();
				localStorage.setItem(mname, 'display');
			}
		}
	}
}
window.menuClick = menuClick;


export function showAdvanced(mname, btnname, defval = "none")
{
    const el = $('#'+mname);
    const button = $('#'+btnname);

	//new
	let storedDisplay = localStorage.getItem(mname);
	if(storedDisplay === null) {
		storedDisplay = defval;
	}

	if(storedDisplay === "none") {
		button.addClass('closed');
        el.hide();
		tagShowHideControl(button, false);
	} else {
		button.removeClass('closed');
        el.show();
		tagShowHideControl(button, true);
	}
}
window.showAdvanced = showAdvanced;

function updateOpenerIcon(link, iconName) {
	const iconElement = link.querySelector("span.fi");
    if (iconElement) {
        const ic = Icon.parse(iconName);
		iconElement.innerHTML = ic.entity;
    }
}

/**
 * @param {string} panelId is html element id or multiple elements class if prefixed with dot
 * @param {string} openerId
 * @param {"open"|"hide"|"toggle"|"show"} show is the same as open but the state is not saved to local storage
 */
export function setAdvancedOptions(panelId, openerId, open) {
	const panels = [];
	if (panelId.startsWith('.')) {
		const query = document.querySelectorAll(panelId);
		panelId = panelId.substring(1);
		query.forEach((panel) => panels.push(panel));
	} else {
		const panel = document.getElementById(panelId);		// should be tbody
		if (panel) panels.push(panel);
	}
	const opener = document.getElementById(openerId || panelId + "_btn"); // should be <a> link with icon and label inside
	const lastLabelBody = document.getElementById(panelId + "_last"); // manage the case when tbody.show-hide-label is the last on the page if closed

    if (opener && panels.length > 0) {
        // Check current state
        let show;
		let saveState = true;
        if (open === "open") show = true;
        else if (open === "show") {
			show = true;
			saveState = false;
		}
        else if (open === "hide") show = false;
        else {
			// Determine from the first panel
			show = (panels[0].style.display === 'none');
		}

        if (show) {
            // show options
			for (let panel of panels) {
				let displayProp;
				switch (panel.tagName) {
					case "TBODY":
						displayProp = "table-row-group";
						break;
					case "THEAD":
						displayProp = "table-header-group";
						break;
					case "TFOOT":
						displayProp = "table-footer-group";
						break;
					case "TR":
						displayProp = "table-row";
						break;
					default:
						displayProp = "block";
				}
				panel.style.display = displayProp;
			}
            updateOpenerIcon(opener, "minus-square-14");
            if (saveState) localStorage.setItem(panelId, "open");
			if (lastLabelBody) lastLabelBody.classList.remove("show-hide-label-last");
        } else {
            // hide options
			for (let panel of panels) {
				panel.style.display = "none";
			}
            updateOpenerIcon(opener, "plus-square-14");
            if (saveState) localStorage.setItem(panelId, "hidden");
			if (lastLabelBody) lastLabelBody.classList.add("show-hide-label-last");
        }
    }
}

/**
 * @param {string} panelId is html element id or multiple elements class if prefixed with dot
 * @param openerId
 */
export function advancedOptions(panelId, openerId = null) {
    setAdvancedOptions(panelId, openerId, "toggle");
}
window.advancedOptions = advancedOptions;

export function initAdvancedOptions(panelId, openerId = null) {
	let saveId = panelId.startsWith('.') ? panelId.substring(1) : panelId;
    const saved = localStorage.getItem(saveId);
    if (saved === "open") setAdvancedOptions(panelId, openerId, "open");
    else setAdvancedOptions(panelId, openerId, "hide");
}
window.initAdvancedOptions = initAdvancedOptions;

/**
 * Show, hide or toggle visibility of specified elements
 * @param {...string} specs - specified IDs of DOM elements. Each ID can have prefix with this meaning
 * 		"-" - hide the ID
 * 		"+" - show the ID
 * 		"" (no prefix) - toggle visibility
 */
export function visibility(...specs) {
	for (let id of arguments) {
		let el;
		let action;
		if (id.charAt(0) === '+') {
			el = $('#'+id.substring(1));
			action = 1;
		} else if (id.charAt(0) === '-') {
			el = $('#'+id.substring(1));
			action = 2;
		} else {
			el = $('#'+id);
			action = 3;
		}
		switch (action) {
			case 1: el.show(); break;
			case 2:	el.hide(); break;
			case 3:	el.toggle(); break;
		}
	}
}

export function uncheck(fname, chname)
{
	const el = document.forms[fname].elements[chname];
    if(el) el.checked = false;
}

export function check(fname, chname)
{
	const el = document.forms[fname].elements[chname];
    if(el) el.checked = true;
}


export function goToURL(menu) {
	let URL = menu.options[menu.selectedIndex].value;
	if (URL.length > 0) {
		window.location.href = URL;
	}
}
window.GoToURL = goToURL;

function getPosition(element)
{
  let positionXY = $(element).position();
  let position=new Object();
  position.x=positionXY.left;
  position.y=positionXY.top;
  return position;
}


/************* PICKER ***************/


function show_picker(entity,
    custValueTarget, custLabelTarget,
    oppValueTarget, oppLabelTarget,
    caseValueTarget, caseLabelTarget,
    constraints, canUnselect)
{
	let pickerWind = window.open(entity+"Pick.do?custValueTarget="+custValueTarget+"&custLabelTarget="+custLabelTarget+
        "&oppValueTarget="+oppValueTarget+"&oppLabelTarget="+oppLabelTarget+
        "&caseValueTarget="+caseValueTarget+"&caseLabelTarget="+caseLabelTarget+
        (canUnselect ? "&unselect=yes":"")+"&constraints="+constraints,
		"Picker", "width=520,height=400,status=yes,resizable=yes,top=200,left=200,scrollbars=yes");
	pickerWind.opener = self;
	pickerWind.focus();
}
window.show_picker = show_picker;

/*
function show_person_picker(custValueTarget, custLabelTarget, personValueTarget, branchValueTarget, constraints, canUnselect)
{
	let pickerWind = window.open("customerPick.do?custValueTarget="+custValueTarget+"&custLabelTarget="+custLabelTarget+
        "&personValueTarget="+personValueTarget+"&branchValueTarget="+branchValueTarget+
        (canUnselect ? "&unselect=yes":"")+"&constraints="+constraints,
		"Picker", "width=500,height=400,status=yes,resizable=yes,top=200,left=200,scrollbars=yes");
	pickerWind.opener = self;
	pickerWind.focus();
}
*/



function show_customer_picker(custValueTarget, custLabelTarget, constraints, canUnselect)
{
	let pickerWind = window.open("customerPick.do?custValueTarget="+custValueTarget+"&custLabelTarget="+custLabelTarget+
        (canUnselect ? "&unselect=yes":"")+"&constraints="+constraints,
		"Picker", "width=500,height=400,status=yes,resizable=yes,top=200,left=200,scrollbars=yes");
	pickerWind.opener = self;
	pickerWind.focus();
}
window.show_customer_picker = show_customer_picker;



function show_product_picker(valueTarget, labelTarget, canUnselect, storeId)
{
	let sid = "0";
	if (storeId) sid = storeId;
	let pickerWind = window.open("productPick.do?store="+sid+"&valueTarget="+valueTarget+"&labelTarget="+labelTarget+(canUnselect ? "&unselect=yes":""),
		"Picker", "width=480,height=360,status=no,resizable=yes,top=200,left=200,scrollbars=yes");
	pickerWind.opener = self;
	pickerWind.focus();
}
window.show_product_picker = show_product_picker;


function show_region_picker(valueTarget, labelTarget, canUnselect)
{
	let pickerWind = window.open("regionPick.do?custValueTarget="+valueTarget+"&custLabelTarget="+labelTarget+(canUnselect ? "&unselect=yes":""),
		"Picker", "width=480,height=360,status=no,resizable=yes,top=200,left=200,scrollbars=yes");
	pickerWind.opener = self;
	pickerWind.focus();
}
window.show_region_picker = show_region_picker;

function show_buscaseitem_picker(customer, inv)
{
	let pickerWind = window.open("busCaseItemPick.do?customer="+customer+"&inv="+inv,
		"Picker", "width=520,height=360,status=no,resizable=yes,top=200,left=200,scrollbars=yes");
	pickerWind.opener = self;
	pickerWind.focus();
}
window.show_buscaseitem_picker = show_buscaseitem_picker;

function show_user_picker(valueTarget, form)
{
    show_user_picker_detailed(valueTarget, form, "resTitle", "responsible");
}
window.show_user_picker = show_user_picker;

function show_user_picker_detailed(valueTarget, form, titleTarget, comboTarget)
{
	let isGroup;
    if (valueTarget.charAt(0) == "#") {
        valueTarget = valueTarget.substring(1);
        isGroup = true;
    } else {
        isGroup=false;
    }
	let pickerWind = window.open("userPick.do?titleTarget="+titleTarget+"&comboTarget="+comboTarget+"&valueTarget="+valueTarget+"&form="+form+(isGroup ? "&isGroup=yes":""),
		"Picker", "width=225,height=450,status=no,resizable=yes,top=200,left=200,scrollbars=yes");
	pickerWind.opener = self;
	pickerWind.focus();
}
window.show_user_picker_detailed = show_user_picker_detailed;

function show_user_picker_detailed2(valueTarget, form, titleTarget, comboTarget)
{
	let isGroup;
    if (valueTarget.charAt(0) == "#") {
        valueTarget = valueTarget.substring(1);
        isGroup = true;
    } else {
        isGroup=false;
    }
	let pickerWind = window.open("userPartyPick.do?titleTarget="+titleTarget+"&comboTarget="+comboTarget+"&valueTarget="+valueTarget+"&form="+form+(isGroup ? "&isGroup=yes":""),
		"Picker", "width=225,height=450,status=no,resizable=yes,top=200,left=200,scrollbars=yes");
	pickerWind.opener = self;
	pickerWind.focus();
}
window.show_user_picker_detailed2 = show_user_picker_detailed2;

function show_transaction_picker(theForm, pickSource)
{
	let pickerWind = window.open("transactionPick.do?src="+(pickSource?1:0)+"&amount="+theForm.refund.value+"&form="+theForm.name,
		"Picker", "width=780,height=360,status=no,resizable=yes,top=200,left=200,scrollbars=yes");
	pickerWind.opener = self;
	pickerWind.focus();
}
window.show_transaction_picker = show_transaction_picker;

function show_accdoc_picker(theForm, pickSource)
{
	let pickerWind = window.open("accDocPick.do?src="+(pickSource?1:0)+"&amount="+theForm.refund.value+"&form="+theForm.name,
		"Picker", "width=780,height=360,status=no,resizable=yes,top=200,left=200,scrollbars=yes");
	pickerWind.opener = self;
	pickerWind.focus();
}
window.show_accdoc_picker = show_accdoc_picker;

function show_salesManager_picker(sourceUser, valueTarget1, labelTarget1, valueTarget2, labelTarget2, managerLevel, bonusModule, canUnselect)
{
	let bm = "0";
	if (bonusModule) bm = bonusModule;
	let pickerWind = window.open("salesManagerPick.do?sourceUser="+sourceUser+"&valueTarget1="+valueTarget1+"&labelTarget1="+labelTarget1+"&valueTarget2="+valueTarget2+"&labelTarget2="+labelTarget2+"&managerLevel="+managerLevel+"&bonusModule="+bm+(canUnselect ? "&unselect=yes":""),
		"Picker", "width=480,height=360,status=no,resizable=yes,top=200,left=200,scrollbars=yes");
	pickerWind.opener = self;
	pickerWind.focus();
}
window.show_salesManager_picker = show_salesManager_picker;

/**
 * @param {string} entity
 * @param {Propagator} propagator
 * @param {string} defaultValue
 */
export function create_object(entity, propagator, defaultValue='') {

	console.log("create_object("+entity+")");
	let srcType = SrcType.PARTY;

	crm.fd.installCreateDialog(true, srcType).then(data => {
		if (data != null) {
			/** @type {PartyGraph} */
			const g = data;
			const party = g.party;

			// Convert data to suggestion
			/** @type {SuggestionItem} */
			let si = { id: {}, title: {} };

			if (Array.isArray(g.parentOrgs) && g.parentOrgs.length > 0) {
				const firstParent = g.parentOrgs[0].party;
				if (firstParent.type === 'ORGANIZATION' || firstParent.type === 'FREELANCER') {
					si.id.main = firstParent.id;
					si.title.main = party.fileAs + " / " + firstParent.fileAs;
					if (party.type === "BRANCH") {
						si.id.branch = party.id;
						si.title.branch = party.fileAs;
					} else {
						si.id.person = party.id;
						si.title.person = party.fileAs;
					}
				}
			} else {
				si.id.main = party.id;
				si.title.main = party.fileAs;
			}

			// Send to the form through the propagator
			propagator.fullPropagate(si);
		}
	});

	// // only createShortCustomer.do exists !!!
	// let objectWind = window.open("createShort"+entity+".do?defaultValue="+defaultValue, "Picker",
	// 	"width=520,height=520,status=yes,resizable=yes,top=200,left=200,scrollbars=yes");
	// objectWind.opener = self;
	// objectWind.parentPropagator = propagator;
	// objectWind.focus();
}
window.create_object = create_object;

window.trinityLink = function(form) {
	let goid = null;
	if (typeof form === 'object') {
		if (form.person) {
			const v = form.person.value;
			if (typeof v === 'string' && parseInt(v)>0) goid = v;
		}
		if (goid === null && form.branch) {
			const v = form.branch.value;
			if (typeof v === 'string' && parseInt(v)>0) goid = v;
		}
		if (goid === null && form.customer) {
			const v = form.customer.value;
			if (typeof v === 'string' && parseInt(v)>0) goid = v;
		}
	}
	if (goid != null) window.location = 'editParty.do?id='+goid;
};

window.refLink = function(entity, id)
{
    if (id=='0' || id=='') return;
    let action;
    if (entity == 'customer') action = 'editCustomer.do?id=';
    else if (entity == 'buscase') action = 'editBusCaseLow.do?id=';
    else if (entity == 'opportunity') action = 'editOpportunity.do?id=';
    else if (entity == 'offer') action = 'editOffer.do?id=';
    else if (entity == 'task') action = 'editTask.do?id=';
    else if (entity == 'event') action = 'editEvent.do?id=';
    else if (entity == 'picture') action = 'openPicture.do?id=';
    else if (entity == 'problem') action = 'editProblem.do?id=';
    else if (entity == 'campaign') action = 'editCampaign.do?id=';
	else action = 'edit'+entity+'.do?id=';
    window.location = action + id;
}

window.refLinkUser = function(entity, id)
{
    if (userId=='') return;
	window.location = 'editUser.do?id=' + id;
}

window.refLinkBlank = function(entity, id)
{
    if (id=='0' || id=='') return;
    let action;
    if (entity == 'customer') action = 'editCustomer.do?id=';
    else if (entity == 'buscase') action = 'editBusCaseLow.do?id=';
    else if (entity == 'opportunity') action = 'editOpportunity.do?id=';
    else if (entity == 'offer') action = 'editOffer.do?id=';
    else if (entity == 'task') action = 'editTask.do?id=';
    else if (entity == 'event') action = 'editEvent.do?id=';
    else if (entity == 'picture') action = 'openPicture.do?id=';
    else if (entity == 'campaign') action = 'editCampaign.do?id=';
    const okno = window.top.open(action+id, 'pictureWindow', 'directories=no,location=no,menubar=no,resizable=yes,scrollbars=yes,status=no,toolbar=no');
    if(okno!=null) okno.location.replace(action+id);
}

/************* CONFIRM SELECTOR ***************/

window.confirmSelector = function(msg) {
    const idx = document.selectorForm.what.selectedIndex;
    if (document.selectorForm.what.options[idx].value.indexOf("confirm=yes") > 0)
    {
        return confirm(msg);
    }
    return true;
}

/************* SHOW ADDRESS ***************/



window.formatZip = function(zip) {
    let formated = "";
    for(let i=0;i<zip.length;i++) {
        if(zip.charAt(i) !== ' ') formated = formated + zip.charAt(i);
    }
    return formated;
};

window.ignoreLastOptions = function(vyber, pocet) {
	let i = 1;
	if (pocet > vyber.length - 1) pocet = vyber.length - 1;
	while (i <= pocet && vyber.selectedIndex !== 0) {
		if (vyber.selectedIndex === (vyber.length - i)) {
			vyber.selectedIndex = 0;
		}
		i++;
	}
};

/**
 * Toggle all checkboxes in a form
 * @param {HTMLFormElement} f - DOM form containing all checkboxes
 * @param {string} propertyName - name of a property (name attribute of checkboxes)
 */
export function toggleFormCheckboxes(f, propertyName) {
	for (let i = 0; i < f.elements.length; i++) {
		const e = f.elements[i];
		if (e.name == propertyName) e.checked = !e.checked;
	}
}

window.toggleFormCheckboxesStartsWith = function (f, startsWith) {
	for (let i = 0; i < f.elements.length; i++) {
		const e = f.elements[i];
		if (e.name.startsWith(startsWith)) e.checked = !e.checked;
	}
};

window.CheckAll = toggleFormCheckboxes;


/*****Find object position*****/

window.findPosX = function (obj) {
	let curleft = 0;
	if (obj.offsetParent) {
		while (obj.offsetParent) {
			curleft += obj.offsetLeft;
			obj = obj.offsetParent;
		}
	} else if (obj.x) {
		curleft += obj.x;
	}
	return curleft;
};

window.findPosY = function (obj) {
	let curtop = 0;
	let printstring = '';
	if (obj.offsetParent) {
		while (obj.offsetParent) {
			printstring += ' element ' + obj.tagName + ' has ' + obj.offsetTop;
			curtop += obj.offsetTop
			obj = obj.offsetParent;
		}
	} else if (obj.y) {
		curtop += obj.y;
	}
	return curtop + 1; //+1 to align under white line - intouch only
};

window.show_quick_help = function(resName) {
	const pickerWind = window.open("quickHelp.do?resName="+resName,"Help", "width=600,height=400,status=no,resizable=yes,top=200,left=200,scrollbars=yes");
	pickerWind.opener = self;
	pickerWind.focus();
};

/** Force debugger STOP (won't be removed by Vite) */
export function DEBUGGER() {
	(new Function("debugger"))();
}

export function openMailWindow(url, params)
{
	const crmMailWindow = JSON.parse(localStorage.getItem('crm_mailWindow'));
	let myLeft = crmMailWindow?.left || 100;
	let myTop = crmMailWindow?.top || 100;
	let myWidth = crmMailWindow?.width || 1000;
	let myHeight = crmMailWindow?.height || 800;

	let docHeight=$(document).height();
	//console.log(" MY H:"+myHeight);
	if(myHeight+myTop > docHeight)
	{
		myTop = 0;
		myHeight = docHeight;
	}

	let docWidth=$(document).width();
	//console.log(" MY W:"+myWidth);
	if(myLeft > docWidth)
	{
		myLeft = 600;
	}
	//alert(myLeft+","+myTop);
	let rnd = Math.floor(Math.random() * 1000);
	let openUrl;
	if (params) {
		// Has params
		const urlSeparator = url.indexOf('?') >= 0 ? "&" : "?";
		if (params.startsWith('?') || params.startsWith('&')) params = params.substring(1);	// remove existing separator
		openUrl = url + urlSeparator + params;
	} else {
		openUrl = url;
	}
	let newWindow = window.open(openUrl, 'Email' + rnd, 'width=' + myWidth + ',height=' + myHeight + ',left=' + myLeft + ',top=' + myTop + ',screenX=100,screenY=100,popup,toolbar=0,location=0,directories=0,status=0,menubar=0,resizable=1,scrollbars=1');

	if (!newWindow) {
		// TODO Ošetřit blokace otevírání oken
		alert("Pop-up blocked!");
		return;
	}

	newWindow.moveTo(myLeft, myTop); //chrome support
	if (window.focus) {newWindow.focus()}
}
window.openMailWindow = openMailWindow;


export function openNewMailWindow(params)
{
	openMailWindow('sendMail.do',params);
}
window.openNewMailWindow = openNewMailWindow;

export function openPassMailWindow(params)
{
	openMailWindow('sendMail.do',params);
}
window.openPassMailWindow = openPassMailWindow;

function generateFileAs(company, titleBefore, firstname, surname, titleAfter) {
	if (company && company.length > 0) {
		// This is company ... ignore person
		return company;
	}
	// This is person
	let name;
	if (surname && surname.length > 0) name = surname;
	else name = "";
	if (firstname && firstname.length > 0) {
		if (name.length > 0) name = name+' ';
		name = name+firstname;
	}
	if (name.length == 0) return "";	// missing data
	if (titleBefore && titleBefore.length > 0) name = name+', '+titleBefore;
	if (titleAfter && titleAfter.length > 0) name = name+', '+titleAfter;
	return name;
}

function setFileAs()
{
	if (!fileAsTouched)
	{
		let company = document.getElementById('company').value;
		let titleBefore = document.getElementById('titleBefore').value;
		let firstname = document.getElementById('firstname').value;
		let surname = document.getElementById('surname').value;
		let titleAfter = document.getElementById('titleAfter').value;

		let name = generateFileAs(company, titleBefore, firstname, surname, titleAfter);
		if (name.length > 0) document.getElementById('fileAs').value = name;
	}
}



/**
 * Find a company based on its number
 * @param {string} ico
 * @param {function} propagator - propagating callback function taking received data as the first argument
 * @param [searchButton] reference to UI button causing this call
 * @param {string} country code
 */
export function findByIco(ico, propagator, searchButton, country)
{
	if (typeof ico !== "string") return;
	if (!country) country = "CZ";
	if (ico.length < 7) return;
	if (searchButton) searchButton.attr('disabled', 'disabled');

	$(".content").css("cursor", "progress");
	if (searchButton) searchButton.css("cursor", "progress");
	$.ajax('searchRegister.do?ico='+ico+"&country="+country).done(function(data) {
		propagator(data);
	}).always(function() {
		if (searchButton) searchButton.removeAttr('disabled');
		$(".content").css("cursor", "auto");
		if (searchButton) searchButton.css("cursor", "pointer");
	});
}

export function findByName(companyName, propagator, searchButton, country) {
	if (!country) country = "CZ";
	let name = typeof companyName === 'string' ? companyName : $('#company').val();
	if (name.length <= 3) return;
	let modal = createModal('queryByCompanyName', 'i/search-reg.jsp?c=FFFFFF', msg('search.business'));
	let searchMsg = $('<div></div>');
	searchMsg.append(document.createTextNode(msg('search.business.progress', name)));
	modal.appendToContent(searchMsg);
	modal.show();
	$.ajax('searchRegister.do?name='+encodeURIComponent(name)+"&country="+country).done(function(data) {
		if (data.ok) {
			let items = data.items;
			if (items.length === 0) {
				// Nothing found
				searchMsg.empty();
				searchMsg.append(document.createTextNode( msg('search.business.404', name)));
			} else {
				let bcontainer = $('<div class="businesses"></div>');
				for (let i = 0; i < items.length; i++) {
					let itemHtml = businessToElement(items[i], modal, propagator, searchButton, country);
					bcontainer.append(itemHtml);
				}
				modal.emptyContent();
				modal.appendToContent(bcontainer);
			}
		} else {
			searchMsg.empty();
			searchMsg.append(document.createTextNode(data.message));
		}
	});
}

function businessToElement(business, modal, propagator, searchButton, country) {
	let cont = $('<div class="business"></div>');
	let row1 = $('<div class="business-row" style="font-weight:bold"></div>');
	row1.append(document.createTextNode(business.company));
	cont.append(row1);
	let row2 = $('<div class="business-row"></div>');
	row2.append(boldE(msg("customer.ico")+": "));
	row2.append(document.createTextNode(business.ico));
	row2.append(spanE(' | '));
	row2.append(boldE(msg("customer.address")+": "));
	row2.append(document.createTextNode(makeAddressString(business)));
	cont.append(row1);
	cont.append(row2);
	cont.on('click', function(e) {
		findByIco(business.ico, propagator, searchButton, country);
		modal.close();
	});
	return cont;
}

function makeAddressString(business) {
	let a = [];
	if (business.street && business.street.length > 0) {
		for (let i = 0; i < business.street.length; i++) a.push(business.street[i]);
	}
	if (business.city && business.city.length > 0) a.push(business.city);
	if (business.zip && business.zip.length > 0) a.push(business.zip);
	return a.join(', ');
}

function boldE(text) {
	let b = $('<b></b>');
	b.append(document.createTextNode(text));
	return b;
}

function spanE(text) {
	let span = $('<span></span>');
	span.append(document.createTextNode(text));
	return span;
}

export function openBrowseFile(valueTarget, labelTarget)
{
	let pickerWind = window.open("browseFile.do?valueTarget="+valueTarget+"&labelTarget="+labelTarget,
		"Browser", "width=520,height=400,status=yes,resizable=yes,top=200,left=200,scrollbars=yes");
	pickerWind.opener = self;
	pickerWind.focus();
}
window.openBrowseFile = openBrowseFile;

/** TIME TRACKING **/
let timingInterval = null;
export function initRunnningTimers() {
	$('.tt-running').each(function() {
		let dataFrom = parseInt($(this).attr('data-from'));
		let diff = new Date().getTime() - dataFrom;
		$(this).attr('data-diff', diff);
	});

	timingInterval = setInterval(function(){
		// Update timers
		$('.tt-running').each(function() {
			let dataFrom = parseInt($(this).attr('data-from'));
			let dataSeconds = parseInt($(this).attr('data-seconds'));
			let diff = parseInt($(this).attr('data-diff'));
			let newSeconds = (new Date().getTime() - dataFrom - diff + 100)/1000;
			$(this).html(formatTimerSeconds(dataSeconds+newSeconds));
		});
	},1000);
}

export function formatTimerSeconds(secs) {
	let hours = Math.floor(secs/3600);
	let mins = Math.floor((secs%3600)/60);
	let s = Math.floor(secs%60);
	return _format_ts(hours)+':'+_format_ts(mins)+':'+_format_ts(s);
}

function _format_ts(num) {
	if (num < 10) return "0"+num;
	return num;
}

function stopTrackingClock() {
	if (timingInterval != null) {
		clearInterval(timingInterval);
		timingInterval = null;
	}
}

function pauseTrackingUI() {
	$('.tt-stop').hide();
	$('.tt-play').show();
	stopTrackingClock();
	let boxes = $('.tt-tracker');
	boxes.removeClass('tt-tracking');
	boxes.addClass('tt-paused');	// change color of box
	$('.tt-timer').removeClass('tt-running');
}

function startTrackingUI(wsID, seconds, from) {
	stopTrackingClock();
	let box = $('#track_ws_'+wsID);
	box.removeClass('tt-paused');
	box.addClass('tt-tracking');	// change color of box
	let timer = box.find('.tt-timer');
	timer.addClass('tt-running');

	timer.attr('data-from', from);
	timer.attr('data-seconds', seconds);
	box.prependTo('#ws_trackers');
	initRunnningTimers();
}


function callStarted() {
	// TODO stop tracking if clock is ticking
}


//QBE AGENDA HEADERS

export function qbeKeyDown(event, inputElement) {
	if (event.keyCode === 13) {
		let value = inputElement.value;
		let column = inputElement.getAttribute("data-qbe");
		$(inputElement).css("width", getOptimalWidth(value,0));

		qbeSent(event,column,value);
	}
}
window.qbeKeyDown = qbeKeyDown;

export function qbeResetWidth(inputElement) {
	$(inputElement).css("width", "");
}
window.qbeResetWidth = qbeResetWidth;

export function qbeSelect(event, inputElement) {
	let value = inputElement.value;
	let column = inputElement.getAttribute("data-qbe");
	if (value === '##DESC') {
		qbeSort(event, column, true);
		return;
	}
	if (value === '##ASC') {
		qbeSort(event, column, false);
		return;
	}

	$(inputElement).css("width", getOptimalWidth($(inputElement).find("option:selected").text(),2));
	qbeSent(event,column,value);
}
window.qbeSelect = qbeSelect;

export function getOptimalWidth(title, add) {
	if (title==='') {
		return "18px";
	}
	else {
		let width = (title.length+add)*8;
		if (width>120) {
			width=120;
		}
		else if (width<(30+add*8)) {
			width=30+add*8;
		}
		return width+"px";
	}
}
window.getOptimalWidth = getOptimalWidth;

function qbeSent(event, column, value) {
	event.preventDefault();
	// Construct form
	let hd = $('<div style="display:none"></div>');
	$('body').append(hd);

	let htmlStr ='<form action="qbe.do" name="thqbeForm" method="post" style="display:none;">'+
					'<input type="hidden" name="f" value="'+column+'" />'+
					'<input type="hidden" name="v" id="thqbeValue"/>'+
				'</form>';
	hd.html(htmlStr);
	$('#thqbeValue').val(value);
	document.forms['thqbeForm'].submit();
	//window.location='qbe.do?f='+f+'&v='+encodeURIComponent(v)+'&encoded=true';
}

function qbeSort(event, column, desc) {
	event.preventDefault();
	const dot = column.indexOf(".");
	const agenda = column.substring(0, dot);
	const col = column.substring(dot + 1);
	window.location='sort.do?agenda='+agenda+'&col='+col+'&desc='+desc;
}

/**
 * items agenda selector - init count
 * @param {number|string} optionValueItem - value of "value" attribute of selector to be altered
 * @param {string} agendaId
 */
export function countWhichSelected(optionValueItem, agendaId) {
	$("."+agendaId+"-which").each(function() {
		$(this).val(optionValueItem);
	});

	let counter = 0;
	$("input[name='items']").each(function() {
		if($(this).prop('checked')) counter++;
	});

	$("."+agendaId+"-which option").each(function() {
		if(optionValueItem == $(this).val()) {
			const splitText = $(this).text().split(" ");
			const newText = counter + ' ' + splitText[1];
			$(this).text(newText);
		}
	});
}
window.countWhichSelected = countWhichSelected;


export function warnWhichSelector(selElement, warnValue)
{
	if ($(selElement).val()===warnValue) {
		$(selElement).addClass("warnSelector");
	}
	else {
		$(selElement).removeClass("warnSelector");
	}
}

/**
 * Used in SelectTag to toggle all checkboxes
 * @param {string} id - DOM id of select continer
 */
export function multiSelectAll(id) {
	let container = $('#'+id);
	let chboxes = container.find('input[type=checkbox]').not(':hidden');
	let total = chboxes.length;
	let checked = container.find('input[type=checkbox]:checked').length;
	chboxes.prop("checked", checked < (total/2));
	container.trigger("change");
}
window.multiSelectAll = multiSelectAll;

/****** MODAL DIALOG ********/

export function createModal(id, icon, titleText, dontCloseOnClick) {
	let body = $('body');
	let md = $('<div class="modal"></div>');
	if (id) md.attr('id', id);
	body.append(md);
	let mc = $('<table class="form modal-content"></table>');
	md.append(mc);

	// Header
	let thead = $('<thead></thead>');
	mc.append(thead);
	let tr = $('<tr></tr>');
	thead.append(tr);
	let th = $('<th></th>');
	if (!icon) icon = 'info-18';
	let icn = skin.iconTag(icon, null);
	th.append(icn)
	th.append(document.createTextNode(" "+titleText));
	tr.append(th);

	let closeIcon = $(Icon.fi("close", null, "cursor:pointer"));
	let close = $('<th style="width:18px;text-align:right"></th>');
	close.append(closeIcon);
	tr.append(close);

	md.close = function() {
		md.remove();
	};
	closeIcon.on('click', md.close);
	if (!dontCloseOnClick) {
		md.on('click', md.close);
	}
	mc.on('click', function(e) { e.stopPropagation(); });

	// Body
	let tbody = $('<tbody></tbody>');
	mc.append(tbody);
	tr = $('<tr></tr>');
	tbody.append(tr);
	let td = $('<td colspan="2"></td>');
	tr.append(td);
	md.appendToContent = function(elm) {
		td.append(elm);
	};
	md.emptyContent = function(elm) {
		td.empty();
	};

	// color of icons
	if (icn.prop("tagName") === "IMG") skin.icon(icn, icn.parent());

	return md;
}

function openModal(modal) {
	// Get the button that opens the modal
	let btn = document.getElementById("myBtn");

	// Get the <span> element that closes the modal
	let span = document.getElementsByClassName("close")[0];

	// When the user clicks on the button, open the modal
	btn.onclick = function() {
		modal.style.display = "block";
	}

	// When the user clicks on <span> (x), close the modal
	span.onclick = function() {
		modal.style.display = "none";
	}

// When the user clicks anywhere outside of the modal, close it
	window.onclick = function(event) {
		if (event.target == modal) {
			modal.style.display = "none";
		}
	}
}

export function openMainMenu() {
	$("#menu-opener").hide();
	$("#menu-closer").show();
	const sidebar = $(".menubar");
	sidebar.addClass("menubar-fixed");
	// extra closing hooks
	window.setTimeout(function() {
		$(window).on("resize.mm", closeMainMenu);
		$("body").on("click.mm", closeMainMenu);
		sidebar.on("click.mmblock", function(e) {
			e.stopPropagation();
		});
	}, 100);
}

export function closeMainMenu() {
	$("#menu-closer").hide();
	$("#menu-opener").show();
	const sidebar = $(".menubar");
	sidebar.removeClass("menubar-fixed");
	// Remove closing hooks
	$(window).off("resize.mm");
	$("body").off("click.mm");
	sidebar.off("click.mmblock");
}
